<template>
    <b-card no-body>
        <!-- <UpdateStatusModal :update_status.sync="modals.update_status" v-on:closeModal="closeModal()" :status_data="status_data" /> -->
        <UpdateCustomerStatusModal :update_status.sync="modals.update_status" v-on:closeModal="closeModal()" :status_data="status_data" />
        <!-- HEADER -->
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>
    
        <!-- SEARCH INPUT -->
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    label="Search"
                    v-model="searchQuery"
                    v-on:input="debouncedHandler"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    >
                    </base-input>
                </b-col>
            </b-row>
        </b-col>
        <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"

                :data="queriedData"
                style="width: 100%;"
                @selection-change="selectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    fixed="left"
                    height="500"
                ></el-table-column>
    
                <!-- STATUS NAME COLUMN -->
                <el-table-column
                    prop="status"
                    label="Status Name"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="mb-0" :class="scope.row.group === 'main' ? 'text-primary font-weight-bold': ''">
                            {{ scope.row.status }}
                        </p>
                    </template>
                </el-table-column>
                
                <!-- STATUS GROUP COLUMN -->
                <el-table-column
                prop="group"
                label="Status Group"
                sortable
                >
                <template slot-scope="scope">
                    <p class="text-capitalize" :class="scope.row.group === 'main' ? 'text-primary font-weight-bold': ''">{{ scope.row.group }}</p>
                </template>
                </el-table-column>

                <!-- PARENT STATUS COLUMN -->
                <el-table-column
                    prop="parent_status"
                    label="Main Status"
                    sortable
                >
                <template slot-scope="scope">
                    <p class="font-weight-bold text-primary">{{ scope.row.parent_status }}</p>
                </template>
                </el-table-column>

								<el-table-column
                prop="tat_day"
                label="TAT Day"
                sortable
                >
                <template slot-scope="scope">
                    <p v-if="scope.row.tat_stop != 1" class="mb-0">{{ scope.row.tat_day }} Days</p>
                    <p v-else class="mb-0 text-danger">TAT Stop</p>
                </template>
                </el-table-column>

                <!-- STATUS CREATED BY COLUMN -->
                <el-table-column
                    prop="created_by"
                    label="Created By"
                    sortable
                >
                </el-table-column>

                <!-- STATUS CREATED AT COLUMN -->
                <el-table-column
                    prop="created_at"
                    label="Date Created"
                    sortable
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.created_at">
                            {{ scope.row.created_at | dateFormatString }}
                        </div>
                    </template>
                    
                </el-table-column>

                <!-- STATUS ACTIONS COLUMN -->
                <el-table-column
                    width="55"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-dropdown :tabindex="scope.row.id" class="py-2">
                            <b class="el-dropdown-link">
                                <b-icon icon="three-dots-vertical">
                                </b-icon>
                            </b>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="editStatus(scope.row)">
                                    Edit
                                </el-dropdown-item>
                                <el-dropdown-item @click.native="deleteStatus(scope.row.status_id)">
                                    Delete
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>

                </el-table-column>

            </el-table>
        </div>

        <!-- FOOTER -->
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>

    </b-card>
</template>

<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { EventBus } from '@/main'

// import UpdateStatusModal from '@/views/Configurations/MainStatusSettings/MainStatusModals/UpdateStatusModal'
import UpdateCustomerStatusModal from '@/views/Configurations/CustomerStatusSettings/CustomerStatusModals/UpdateCustomerStatusModal'


import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'



export default {
    name: 'status-setting-table',
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        BasePagination,
        UpdateCustomerStatusModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    props: {
        all_status:{

        },
        statusMain: {
            type: Array
        }
    },
    data() {
        return {
            modals: {
                update_status: false,
            },
            isTableLoading: true,
            propsToSearch:['status'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            status_data: {},
        }
    },
    created(){
        this.getStatus()
    },  
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);

        EventBus.$on('refresh-status', this.getStatus)
    },
    beforeUnmount() {
        EventBus.$off('refresh-status', this.getStatus)
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
        getStatus(){
            this.isTableLoading = true
            axios.get(services.customer + 'customer/statuses', {headers: getHeader()})
            .then(res => {
                this.tableData = res.data.data
                this.isTableLoading = false
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        editStatus(status){
            this.status_data = status
            this.modals.update_status = true;
        },
        deleteStatus(status_id){
            swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(services.customer + 'customer/statuses/' + status_id, {headers: getHeader()})
                    .then(res => {
                            this.getStatus()
                            this.notifySuccess('<b>Status: </b> - Successfully Deleted.')
                            return 
                        })
                        .catch(e => {
                            this.isTableLoading = false
                            this.errorFunction(e)
                        })
                }
            })
        },
        closeModal(){
            this.modals.update_status = false
        },
    }
}
</script>